module.exports = __webpack_public_path__ + "static/feature4-ccdb05ac8797f12126ba077bf7f143ca.png";